import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { SPORTSBOOK_ROUTES } from '../components/router/constants.js';

const useSportsbookLocation = () => {
	const { pathname } = useLocation();

	const isSportsbookLocation = useMemo(() => SPORTSBOOK_ROUTES.some(route => pathname.startsWith(route)), [pathname]);

	return {
		isSportsbookLocation
	};
};

export default useSportsbookLocation;
